import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import { Toggle } from '@/ui';

interface ZuulToggleSwitchProps {
  value?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  children?: React.ReactNode;
  labelComponent?: React.ReactNode;
  noMargin?: boolean;
}

const ZuulToggleSwitch = ({
  value = false,
  onChange,
  disabled = false,
  labelComponent,
  children,
  noMargin = false,
}: ZuulToggleSwitchProps) => (
  <Stack
    direction='row'
    spacing={2}
    sx={{ mb: noMargin ? 0 : 2, alignItems: 'center', justifyContent: 'space-between' }}
  >
    {labelComponent ? labelComponent : <FormLabel>{children}</FormLabel>}
    <Toggle checked={value} onChange={onChange} disabled={disabled} offColor='error' />
  </Stack>
);

export default ZuulToggleSwitch;
